import React from 'react'
import styled from 'styled-components'

export default function Footer() {
  return (
    <Container className="section section-footer">
      <div className="container">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="logo"></div>
          <div className="text-center">School of Information Technology, King Mongkut's Institute of Technology Ladkrabang</div>

        </div>
      </div>
    </Container>
  )
}

const Container = styled.section`
  padding-top: 8px;
  padding-bottom: 8px;
  color: var(--text-color);
  background-color: var(--secondary-color);
`